import { render, staticRenderFns } from "./search-other-boat-types-in-location.vue?vue&type=template&id=3c3136c0&scoped=true"
import script from "./search-other-boat-types-in-location.vue?vue&type=script&lang=js"
export * from "./search-other-boat-types-in-location.vue?vue&type=script&lang=js"
import style0 from "./search-other-boat-types-in-location.vue?vue&type=style&index=0&id=3c3136c0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c3136c0",
  null
  
)

export default component.exports